export default __webpack_public_path__ + "static/media/landing.98905029.png";